var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikesLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/likes-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/likes-large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6120318,5.41451605 C18.7237702,4.50883952 17.5187786,4 16.262292,4 C15.0058055,4 13.8008138,4.50883952 12.9125522,5.41451605 L11.9997697,6.3447575 L11.0869871,5.41451605 C9.23697693,3.52912055 6.23751781,3.52912057 4.38750764,5.4145161 C2.53749747,7.29991163 2.53749745,10.3567417 4.38750759,12.2421373 L5.30029015,13.1723788 L11.9997697,20 L18.6992492,13.1723788 L19.6120318,12.2421373 C20.5007104,11.3368858 21,10.1088462 21,8.82832667 C21,7.54780716 20.5007104,6.31976753 19.6120318,5.41451605 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 1.69
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesLarge);
export default __webpack_public_path__ + "static/media/likes-large.d8c0f4062c4338c4e0adef40e7ffa5e0.svg";
export { ForwardRef as ReactComponent };